var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconLock = function SvgIconLock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9501\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u89C4\\u83032",
    transform: "translate(-1178.000000, -331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9501\\u5907\\u4EFD",
    transform: "translate(1178.000000, 331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(1.581055, 1.037720)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#A6A9B6",
    strokeWidth: 1.5,
    x: 0.75,
    y: 3.75,
    width: 7.5,
    height: 5.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45678711,5.02600098 C5.00907186,5.02600098 5.45678711,5.47371623 5.45678711,6.02600098 C5.45678711,6.39568201 5.25618749,6.71851048 4.95790141,6.89157323 L4.95678711,7.5 C4.95678711,7.77614237 4.73292948,8 4.45678711,8 C4.18064473,8 3.95678711,7.77614237 3.95678711,7.5 L3.95665761,6.89214385 C3.65782834,6.71922072 3.45678711,6.3960887 3.45678711,6.02600098 C3.45678711,5.47371623 3.90450236,5.02600098 4.45678711,5.02600098 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#A6A9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52285156,3.98222656 L2.52285156,2.85722656 C2.52285156,1.82169266 3.41828206,0.982226563 4.52285156,0.982226563 C5.62742106,0.982226563 6.52285156,1.82169266 6.52285156,2.85722656 L6.52285156,3.98222656",
    id: "\\u8DEF\\u5F84",
    stroke: "#A6A9B6",
    strokeWidth: 1.4
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-lock.4d5d2932.svg";